import { render, staticRenderFns } from "./SelectList.vue?vue&type=template&id=08a47663"
import script from "./SelectList.vue?vue&type=script&lang=js"
export * from "./SelectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports